import React from 'react';

const MAPA = {
  ativo: { texto: 'Ativo', classe: 'sf-badge-success' },
  inativo: { texto: 'Inativo', classe: 'sf-badge-neutral' },
  rascunho: { texto: 'Rascunho', classe: 'sf-badge-warn' },
  confirmado: { texto: 'Confirmado', classe: 'sf-badge-success' },
  cancelado: { texto: 'Cancelado', classe: 'sf-badge-danger' },
  perda: { texto: 'Perda', classe: 'sf-badge-danger' },
  quebra: { texto: 'Quebra', classe: 'sf-badge-danger' },
  avaria: { texto: 'Avaria', classe: 'sf-badge-danger' },
  outro: { texto: 'Outro', classe: 'sf-badge-neutral' },
  super_admin: { texto: 'Super Admin', classe: 'sf-badge-dark sf-badge-plain' },
  admin: { texto: 'Admin', classe: 'sf-badge-success sf-badge-plain' },
  operador: { texto: 'Operador', classe: 'sf-badge-outline sf-badge-plain' },
};

export default function StatusBadge({ status }) {
  const info = MAPA[status] || { texto: status, classe: 'sf-badge-neutral' };
  return <span className={`sf-badge ${info.classe}`}>{info.texto}</span>;
}
